import React from 'react';

const TagList = ({ tags, selectedTags, tagClickHandler }) => {
    return (
        <div className={"tag-list"}>
            {[...tags.keys()].sort().map((tag) => {
                let label = tag || "*no-tag*";
                label += " (" + tags.get(tag) + ")"
                return (<div
                    className={"item clickable" + (selectedTags.includes(tag) ? " active" : "")}
                    key={tag}
                    onClick={() => tagClickHandler(tag)}
                >
                    {label}
                </div>)
            })}
        </div>
    )
}

export default TagList;
